<template>
  <main role="main">
    <b-container class="py-5">
      <div class="mb-4">
        <b-form-checkbox v-model="isLoading">Show loading</b-form-checkbox>
      </div>
      <div class="text-center">
        <b-spinner type="grow" variant="primary" v-if="isLoading"></b-spinner>
      </div>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";

  @Component
  export default class TestComponent extends BaseComponent {

    isLoading = false;

    mounted() {

    }

  }
</script>
